import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom-v7'

import { loginWithAuth0 } from '../../redux/storeConfig/slices/slice.auth'

export default function Auth0Callback() {
  const { status } = useSelector(state => state.auth)
  const dispatch = useDispatch()

  const { getIdTokenClaims, user, isAuthenticated } = useAuth0()

  const navigate = useNavigate()

  useEffect(() => {
    const fetchAuth0Token = async () => {
      if (isAuthenticated && user) {
        try {
          const idToken = await getIdTokenClaims()
          await dispatch(loginWithAuth0({ idToken, user, isAuthenticated }))
        } catch {
          navigate('/login')
        }
      }
    }

    fetchAuth0Token()
  }, [dispatch, getIdTokenClaims, isAuthenticated, navigate, user])

  useEffect(() => {
    if (status === 'failed') {
      navigate('/login')
    }
  }, [status, navigate])

  return <></>
}
